import React from 'react';

import i18n from '../../i18n';

// @mui
import { TextField, MenuItem } from '@mui/material';

export default class DialogItemsField extends React.Component {
    onChange(event) {
        this.props.onChange(event.target.name, event.target.value);
    }

    render() {
        // field, value, cache, onChange

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        let id = this.props.field.id;
        let name = this.props.field.label;
        let value = this.props.value;
        let onlyRead = !!this.props.field.onlyRead;
        let disabledByTemplate = !!this.props.field.disabledByTemplate;
        const disabled = onlyRead || disabledByTemplate;
        const noTranslate = !!this.props.field.noTranslate;

        return (
            <TextField
                key={name}
                select
                margin="dense"
                id={id}
                name={id}
                disabled={disabled}
                label={translatedName}
                value={value || ''}
                fullWidth
                onChange={(event) => this.onChange(event)}
            >
                {this.props.field.items.map((item) => (
                    <MenuItem key={item} value={item}>
                        {noTranslate ? item : i18n.t(`enums.${item}`)}
                    </MenuItem>
                ))}
            </TextField>
        );
    }
}
